import React from "react"
import axios from "axios"
import AppStore from "../AppStore"
import {observer} from "mobx-react"
import { HashRouter as Router, Route, Link } from "react-router-dom";
import { Redirect } from "react-router-dom";
var _ = require('lodash');

@observer
class Representants extends React.Component {
  getValue(){
    axios.post("/api/v1/experts/app/representants",{id: AppStore.rdv.id}).then((data)=>{
        this.setState(data.data)
        this.setState({loaded: true})
    })

  }
  componentDidMount(){
    M.updateTextFields();
  }
  constructor(props) {
    super(props);
    this.updateDetails = _.debounce(this.updateDetails.bind(this), 750)
    this.prop_email = this.prop_email.bind(this)
    this.loc_email = this.loc_email.bind(this)
    this.prop_nom = this.prop_nom.bind(this)
    this.loc_nom = this.loc_nom.bind(this)
    this.state = {
      representant_proprietaire_nom: "",
      representant_proprietaire_email: "",
      representant_locataire_nom: "",
      representant_locataire_email: "",
      loaded: false
    };
    this.getValue()
  }
  prop_email(e){
    this.setState({representant_proprietaire_email: e.target.value})
    this.updateDetails()
  }
  prop_nom(e){
    this.setState({representant_proprietaire_nom: e.target.value})
    this.updateDetails()
  }
  loc_nom(e){
    this.setState({representant_locataire_nom: e.target.value})
    this.updateDetails()
  }
  loc_email(e){
    this.setState({representant_locataire_email: e.target.value})
    this.updateDetails()
  }
  updateDetails(){
    console.log("update")
    axios.post("/api/v1/experts/app/validateRepresentants",{
      id: AppStore.rdv.id,
      data: {
      representant_proprietaire_nom: this.state.representant_proprietaire_nom,
      representant_proprietaire_email: this.state.representant_proprietaire_email,
      representant_locataire_nom: this.state.representant_locataire_nom,
      representant_locataire_email: this.state.representant_locataire_email
    }
    }).then((data)=>{
    })
  }

  render () {
    if(!this.state.loaded){
      return(
      <React.Fragment>
      <h1 className="center">Chargement en cours des données du serveurs</h1>
      </React.Fragment>

        )
    }else{
      return (
        <React.Fragment>
        <h1 className="center">Les representants</h1>
        <p className="center">Laissez vide si les personnes sont présente physiquement</p>
        <div className="container">
            <div className="row">
            <div className="col s6">
              <h2 className="center">Propriétaire</h2>
              <div className="input-field">
                <input type="text" onChange={this.prop_nom} value={this.state.representant_proprietaire_nom}/>
                <label className="active" htmlFor="text">Nom</label>
              </div>
              <div className="input-field">
                <input type="email" onChange={this.prop_email} value={this.state.representant_proprietaire_email}/>
                <label className="active" htmlFor="email">email</label>
              </div>
            </div>
            <div className="col s6">
              <h2 className="center">Locataire</h2>
              <div className="input-field">
                <input type="text" onChange={this.loc_nom} value={this.state.representant_locataire_nom}/>
                <label className="active" htmlFor="text">Nom</label>
              </div>
              <div className="input-field">
                <input type="email" onChange={this.loc_email} value={this.state.representant_locataire_email}/>
                <label className="active" htmlFor="email">email</label>
              </div>
            </div>
            </div>
        </div>
        <div className="row">
        <div className="col s3 offset-s9">
          <Link className="btn btn-large" to="/CheckPaiement">Suivant</Link>
        </div>
        </div>

        </React.Fragment>
      );
    }
  }
}

export default Representants
